// import library
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
// import context
import { AuthContext } from "../../context";
// import component
import Layout from "../../layouts/Layout";
import LoaderIcon from "../../components/Common/Icon/Loader";
// import files
import { env } from "../../env";

const ProfileIndex = () => {
    // variables
    const { t } = useTranslation();
    const authContext = useContext(AuthContext);
    const location = useLocation();
    const [isLoader, setIsLoader] = useState(true);
    const [customerData, setCustomerData] = useState({});
    const [showTab, setShowTab] = useState('overview');
    const activeTab = "border-b border-blue-normal text-blue-normal";

    // functions
    useEffect(() => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        const fetchData = async () => {
            getCustomerDataApi(baseUrl, token);
        };
        fetchData();
    }, []);
    
    const getCustomerDataApi = async (url, token) => {
        const headers = {
            "Accept" : "application/json",
            "Content-Type" : "application/json",
            "Authorization": `Bearer ${token}`
        };

        await axios.post(url+"/api/User/GetUserDetailsByUserID", {
            "UserName" : authContext.userInfo.userName
        },{ headers })
        .then((response) => {
            setCustomerData(response.data);
            setIsLoader(false);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    }
    const openTab = (e, value) => {
        setShowTab(value);
    }

    return (
        <Layout>
            <div className="space-y-2 sm:space-y-4">
                {/* first box */}
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="sm:text-2xl font-semibold capitalize">{ t('profile overview') }</h1>
                        <p className="text-light-400 text-xs sm:text-sm capitalize">{ t('profile') } / { t('profile overview') }</p>
                    </div>
                </div>
                {
                    isLoader
                    ?
                        <LoaderIcon />
                    :
                    <div className="space-y-2 sm:space-y-4">
                        <div className="py-4 bg-white border border-white rounded-lg shadow-around">
                            <div className="px-4">
                                <h1 className="sm:text-lg font-semibold"><span className="capitalize">{ t('address & contact') }</span></h1>
                            </div>
                            <div className="my-3 border-t border-background-normal"></div>
                            <div className="px-4 text-xs sm:text-base">
                                <div className="grid grid-cols-3 items-center gap-3">
                                    <div className="text-light-400 capitalize">
                                        { t('name')}
                                    </div>
                                    <div className="col-span-2 font-medium">
                                        {customerData.firstName} {customerData.lastName}
                                    </div>
                                </div>
                                <div className="my-3 border-t border-dashed border-background-normal"></div>
                                <div className="grid grid-cols-3 items-center gap-3">
                                    <div className="text-light-400 capitalize">
                                        { t('address')}
                                    </div>
                                    <div className="col-span-2 font-medium">
                                        {customerData.address}
                                    </div>
                                </div>
                                <div className="my-3 border-t border-dashed border-background-normal"></div>
                                <div className="grid grid-cols-3 items-center gap-3">
                                    <div className="text-light-400 capitalize">
                                        { t('phone number')}
                                    </div>
                                    <div className="col-span-2 font-medium">
                                        {customerData.phone}
                                    </div>
                                </div>
                                <div className="my-3 border-t border-dashed border-background-normal"></div>
                                <div className="grid grid-cols-3 items-center gap-3">
                                    <div className="text-light-400 capitalize">
                                        { t('email address')}
                                    </div>
                                    <div className="col-span-2 font-medium">
                                        {customerData.email}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="py-4 bg-white border border-white rounded-lg shadow-around">
                            <div className="px-4">
                                <h1 className="sm:text-lg font-semibold capitalize">{ t('company overview')}</h1>
                            </div>
                            <div className="my-3 border-t border-background-normal"></div>
                            <div className="px-4 text-xs sm:text-base">
                                <div className="grid grid-cols-3 items-center gap-3">
                                    <div className="text-light-400 capitalize">
                                        { t('name')}
                                    </div>
                                    <div className="col-span-2 font-medium">
                                        {customerData.company.companyName}
                                    </div>
                                </div>
                                <div className="my-3 border-t border-dashed border-background-normal"></div>
                                <div className="grid grid-cols-3 items-center gap-3">
                                    <div className="text-light-400 capitalize">
                                        { t('description')}
                                    </div>
                                    <div className="col-span-2 font-medium">
                                        {customerData.company.companyDescription}
                                    </div>
                                </div>
                                <div className="my-3 border-t border-dashed border-background-normal"></div>
                                <div className="grid grid-cols-3 items-center gap-3">
                                    <div className="text-light-400 capitalize">
                                        { t('industry')}
                                    </div>
                                    <div className="col-span-2 font-medium">
                                        {customerData.company.industry}
                                    </div>
                                </div>
                                <div className="my-3 border-t border-dashed border-background-normal"></div>
                                <div className="grid grid-cols-3 items-center gap-3">
                                    <div className="text-light-400 capitalize">
                                        { t('website')}
                                    </div>
                                    <div className="col-span-2 font-medium">
                                        {customerData.company.website}
                                    </div>
                                </div>
                                <div className="my-3 border-t border-dashed border-background-normal"></div>
                                <div className="grid grid-cols-3 items-center gap-3">
                                    <div className="text-light-400 capitalize">
                                        { t('sales person')}
                                    </div>
                                    <div className="col-span-2 font-medium">
                                        {customerData.salespersonname}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </Layout>
    )
}

export default ProfileIndex;